import { makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import LanguageContext from '../../../contexts/languageContext';
import { SubmitButton } from '../../UI';
import { PropTypes } from 'prop-types';
import MessagesContext from '../../../contexts/messagesContext';
import DOWNLOAD_ICON from '../../../assets/images/download.png';

const styles = makeStyles((theme) => ({
    tr: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        margin: '0 40px',
        '&:nth-child(1)': {
            marginRight: '0 '
        },
        '&:nth-child(2)': {
            marginRight: '0 '
        },
        [theme.breakpoints.down(1025)]: {
            backgroundColor: '#fff',
            padding: '7px 16px 7px 7px',
            borderRadius: '6px',
            margin: '16px 0'
        }
    },
    title: {
        fontSize: '16px',
        color: '#3d454a',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal'
    },
    buttonContainer: {
        // marginRight: '30px',
        [theme.breakpoints.down(1025)]: {
            marginRight: '0'
        }
    },
    downloadIcon: {
        margin: '0px 10px'
    }
}));

const ReportItem = ({ item, getEntityExport }) => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    return (
        <>
            <div className={classes.tr}>
                <div className={classes.title}>{lang === 'fa' ? item.title : item.en_title}</div>
                <div className={classes.buttonContainer}>
                    <SubmitButton disableSubmit fullWith mr="0" handleClick={getEntityExport}>
                        <img
                            className={classes.downloadIcon}
                            src={DOWNLOAD_ICON}
                            width="17.7"
                            alt="download"
                        />
                        {messages.download}
                    </SubmitButton>
                </div>
            </div>
        </>
    );
};

ReportItem.propTypes = {
    item: PropTypes.object,
    getEntityExport: PropTypes.func
};

export default ReportItem;
